<template>
  <modal @close="closeissueView">
    <template slot="header">
      <h3 class="modal-title">Reclamación {{issue._id}}</h3>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="closeissueView"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <issue-modal-consumidor
        @close="closeissueView"
        :issue="issue_detail"
        v-if="!isLoading && issue.category=='CONSUMIDOR'"
      ></issue-modal-consumidor>
      <issue-modal-cliente :issue="issue_detail" v-if="!isLoading && issue.category=='CLIENTE'"></issue-modal-cliente>
    </template>

    <template slot="footer">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        :background-color="bgColor"
        :color="color"
        :height="height"
        :loader="loader"
        :opacity="1"
      ></loading>
      <!-- <md-button class="md-danger md-simple" @click="closeissueView">Cerrar</md-button> -->
    </template>
  </modal>
</template>
<script>
import { Modal } from "@/components";
import IssueModalCliente from "./IssueModalCliente";
import IssueModalConsumidor from "./IssueModalConsumidor";
import Loading from "vue-loading-overlay";
import { apiServer, staticServer, florette_web } from "@/globalVars.js";

export default {
  name: "issue-modal",
  components: {
    Modal,
    IssueModalCliente,
    IssueModalConsumidor,
    Loading,
  },
  props: {
    issue: {
      type: Object,
      required: false,
      default: () => {
        date: null;
      },
    },
  },
  data() {
    return {
      issue_detail: null,
      isLoading: true,
      color: "#43a047",
      loader: "dots",
      fullPage: true,
      height: 48,
      bgColor: "#ffffff",
    };
  },
  methods: {
    closeissueView() {
      this.issue.status = this.issue_detail.status;
      this.$emit("close");
    },
    getIssueDetail() {
      this.isLoading = true;
      this.$store.dispatch("reclamacion/getReclamacion", this.issue._id);
    },
  },
  watch: {
    status_reclamacion() {
      if (this.$store.state.reclamacion.current_status.loaded) {
        if (this.$store.state.reclamacion.current != null) {
          this.issue_detail = this.$store.state.reclamacion.current;
        } else {
          this.issues = null;
        }
        this.isLoading = false;
      }
    },
  },
  computed: {
    status_reclamacion() {
      return this.$store.state.reclamacion.current_status;
    },
  },
  mounted() {
    this.getIssueDetail();
  },
};
</script>

<style lang="scss" scoped>
</style>


